module.exports = __webpack_public_path__ + "img/login_bg.1bea715f.jpg";